import amenitiesMap from "../content/amenities-mapping";

/**
 * Converts list of amenity IDs into content formatted for 'IconTextList' component
 * ('listItems' prop). List is also sorted alphabetically.
 *
 * @param {Array} amenityIdList - List of IDs from service, e.g., ["event_space", "change_rooms"].
 * @param {boolean} [hasOneLinkTranslation=false] - Validates if has one link translation.
 * @param {boolean} [hasFeatured=false] - Validates if has a featured icon.
 * @param {string} [featured=""]  - Featured Icon to put in the first place, e.g., "footwear".
 * @returns {Array} - List of Objects with iconName and text for each amenity
 *                    example: [
 *                               { iconName: "changeRoom", text: "Change rooms" },
 *                               { iconName: "eventSpace", text: "Event space" }
 *                            ]
 */
const getAmenitiesIconTextList = (
  amenityIdList = [],
  hasOneLinkTranslation = false,
  hasFeatured = false,
  featured = ""
) => {
  return amenityIdList
    .filter((amenityId) => amenitiesMap[amenityId])
    .map((amenityId) => amenitiesMap[amenityId])
    .map((val) => ({
      ...val,
      hasOneLinkTranslation
    }))
    .sort((left, right) => {
      if (hasFeatured && left.iconName === featured) {
        return -1;
      }
      if (hasFeatured && right.iconName === featured) {
        return 1;
      }

      return String(left.text).localeCompare(right.text);
    })
    .filter(
      (amenitie) =>
        (!hasFeatured && amenitie.iconName !== featured) || hasFeatured
    );
};

export default getAmenitiesIconTextList;
